import React, { Component, forwardRef } from "react";

export default function Banner() {
  return (
    <section className="banner">
      <div>
        <p className="banner-txt">
          MAX The Creative 5th 후원사 및 제휴사 모집 중
        </p>
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSf5t9WroVHUFfZAxE8MMrLYzNetIsPxn0AgnJdbYGYaXi6ftg/viewform?usp=dialog"
          target="_blank"
        >
          문의하기
        </a>
      </div>
    </section>
  );
}
